import React, { Component } from 'react'
import { imageAddress } from '../../utils/useful'

export default class SimilarProducts extends Component {

    render() {

        return (
            <div className='br-10 flex-column product-view-box bg-white h-100' onClick={() => this.props.settings.onClick("singleproduct")}>
                <div className='flexcc w-100 p-2'>
                    <img className='w-100 br-5' style={{ aspectRatio: '1 / 1', objectFit: 'cover' }} src={imageAddress(this.props.data.images)} />
                </div>
                <div className=' pb-3 pt-2'>
                    <p className='font-size-16 weight-600 main-c4 px-3'>{this.props.data.name}</p>
                    <p className='font-size-12 weight-400 main-c7 px-3 line-clamp2 mt-1'>this is a test description that the box will only show 2 line of it</p>
                    <div className='mt-2 flexcb px-3'>
                        <p className='font-size-15 main-c4 '>{this.props.data.price} {this.props?.data?.priceSttings?.currency} $</p>
                        <p className='font-size-12 main-c8 text-lined'>{this.props.data.price} {this.props?.data?.priceSttings?.currency} $</p>
                    </div>
                    <div className='d-flex' style={{ justifyContent: 'flex-end', paddingRight: '10px' }}>
                        <button className='flexc mt-2'>
                            <p className='w-100 font-size-11' style={{ color: '#007aff' }}>View Product</p>
                            <img className='flexcc mt-1 mld-1' width={16} src='/assets/icons/point-right-blue.svg' />
                        </button>
                    </div>
                </div>
            </div>

        )
    }
}
